import { ActionState, ActionStateEnum } from "./ActionState";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { Entity, Events, eventsManager, Listener, math } from "@rhinov/savane-js";

export class AbsoluteIdleState extends ActionState {

    state: number = ActionStateEnum.AbsoluteIdle;
    _previousGridState = PlanManager.getInstance().scrollWindow.grid._isGridVisible;
    floorChangeListener: Listener | null;

    constructor() {
        super();

        PlanManager.getInstance().scrollWindow.grid._isGridVisible = false;
        PlanManager.getInstance().scrollWindow.minzoomindex = 10;
        eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, false);
        this.floorChangeListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.lockView.bind(this));
    }

    getAction(): number {
        return ActionStateEnum.AbsoluteIdle;
    }
    lockView() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    lockViewNoOffset() {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        //Hide grid
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, false);
        //Hide room area
        PlanManager.getInstance().mustShowRoomArea = false;
        eventsManager.instance.dispatch(Events.TOGGLE_ROOM_AREA, false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    moveMouseCursor(cursorPosition: math.vec3) {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);
        return null;
    }
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Array<Entity>, mouseButton: number): ActionState | null {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._startDragging(posx, posy, true);
        return null;
    }
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Array<Entity>, mouseButton: number) {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);
        return null;
    }

    isDecorationState(): boolean {
        return (true);
    }

    dispose() {
        if (this.floorChangeListener !== null) {
            eventsManager.instance.removeListener(this.floorChangeListener);
        }
    }
}
